import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "bkash"
    }}>{`bKash`}</h2>
    <p>{`bKash is a mobile financial service in Bangladesh that allows users to make financial transactions through their mobile phones. It was launched in 2011 as a subsidiary of BRAC Bank, one of the leading banks in Bangladesh. bKash provides a range of services such as money transfer, mobile recharge, bill payment, merchant payments, and more.`}</p>
    <h3 {...{
      "id": "bkash-integrate-inside-pickbazar"
    }}>{`bKash integrate inside PickBazar.`}</h3>
    <p>{`Please follow & complete this steps for bKash integration for your e-commerce system.`}</p>
    <ul>
      <li parentName="ul">{`First go to settings from PickBazar admin dashboard. Inside settings you will find Currency option.Select Bangladeshi Taka (BDT) Currency. bKash primarily operates in the currency of Bangladesh, which is the Bangladeshi Taka (BDT).`}</li>
    </ul>
    <p><img alt="bkash-gateway.png" src={require("../images/payment-images/bkash-gateway.png")} /></p>
    <ul>
      <li parentName="ul">{`Inside api there is `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. You have to copy & paste this line of codes inside the `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. We will discuss later about how to create those API keys in `}<a parentName="li" {...{
          "href": "https://www.bkash.com/"
        }}>{`bkash official website`}</a>{`.`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`BKASH_SANDBOX=true  #for production use false
BKASH_APP_KEY=
BKASH_APP_SECRET=
BKASH_USERNAME=
BKASH_PASSWORD=
`}</code></pre>
    <b>SHOP_URL=[YOUR_SHOP_URL]</b> This parameter is must have in .env file when bKash is using. Otherwise the payment redirection will be broken.
    <h2 {...{
      "id": "how-to-create--setup-bkash-information-properly"
    }}>{`How to create & setup bKash information properly?`}</h2>
    <ul>
      <li parentName="ul">{`Go to the `}<a parentName="li" {...{
          "href": "https://www.bkash.com/"
        }}>{`bKash official website`}</a>{` & Click on Live Chat Button,`}</li>
    </ul>
    <p><img alt="bkash-home" src={require("../images/payment-images/bkash-home.png")} /></p>
    <ul>
      <li parentName="ul">{`After That Click on `}<inlineCode parentName="li">{`customer service`}</inlineCode>{` for new merchant API Keys.`}</li>
    </ul>
    <p><img alt="customer-service" src={require("../images/payment-images/customer-service.png")} /></p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Then apply API keys for merchant mobile Number.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`3-10days after they with give you your `}</p>
      </li>
    </ul>
    <p><inlineCode parentName="p">{`BKASH_APP_KEY`}</inlineCode>{`
`}<inlineCode parentName="p">{`BKASH_APP_SECRET`}</inlineCode>{`
`}<inlineCode parentName="p">{`BKASH_USERNAME`}</inlineCode>{`
&`}<inlineCode parentName="p">{`BKASH_PASSWORD`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "special-notes-for-bkash"
    }}>{`Special Notes for bKash.`}</h2>
    <p>{`If we have used any third party system/plugin/packages, then we have always encouraged our respected customers to follow the official documentation for detailed & in-depth knowledge.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.bka.sh/"
        }}>{`bKash official documentation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.bka.sh/reference/createpaymentusingpost"
        }}>{`bKash API reference`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      